import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

import { InstallationMaalerAflaesningMedMaalerType } from "@e-forsyning/common/maaler";

import { FlyttemeddelelseIndstillinger } from "../model/flyttemeddelelse-indstillinger.model";
import { FlyttemeddelelseAflaesningFormBuilder } from "./aflaesning/flyttemeddelelse-aflaesning.form-builder";
import { FlyttemeddelelseAnmelderFormBuilder } from "./anmelder/flyttemeddelelse-anmelder.form-builder";
import { FlyttemeddelelseFaktureringsadresseFormBuilder } from "./faktureringsadresse/flyttemeddelelse-faktureringsadresse.form-builder";
import { FlyttemeddelelseIndflytterFormBuilder } from "./indflytter/flyttemeddelelse-indflytter.form-builder";
import { FlyttemeddelelseUdbetalingFormBuilder } from "./udbetaling/flyttemeddelelse-udbetaling.form-builder";
import { FlyttemeddelelseUdflytterFormBuilder } from "./udflytter/flyttemeddelelse-udflytter.form-builder";

export class FlyttemeddelelseFormBuilder {
    public static opretForm(
        indstillinger: FlyttemeddelelseIndstillinger,
        maalerAflaesning: InstallationMaalerAflaesningMedMaalerType
    ): UntypedFormGroup {
        const form = new UntypedFormBuilder().group({
            indflytter: FlyttemeddelelseIndflytterFormBuilder.opretForm(),
            udflytter: FlyttemeddelelseUdflytterFormBuilder.opretForm(indstillinger.erUdflytterMailSynlig),
            udbetaling: FlyttemeddelelseUdbetalingFormBuilder.opretForm(),
            faktura: FlyttemeddelelseFaktureringsadresseFormBuilder.opretForm(),
            anmelder: FlyttemeddelelseAnmelderFormBuilder.opretForm(),
            aflaesning: FlyttemeddelelseAflaesningFormBuilder.opretForm(maalerAflaesning, indstillinger.erAflaesningFravalgt)
        });

        return form;
    }
}
